class AppConstants {
  static get APP_VERSION() {
    return process.env.REACT_APP_VERSION;
  }

  static get APP_NAME() {
    return process.env.REACT_APP_NAME;
  }

  static get APP_ENVIRONMENT() {
    return process.env.REACT_APP_ENVIRONMENT;
  }

  static get AUTH_SERVICE_BASE_URL() {
    return process.env.REACT_APP_AUTH_SERVICE_BASE_URL;
  }

  static get AUTH_REDIRECT_URL() {
    return process.env.REACT_APP_AUTH_REDIRECT_URL;
  }

  static get REPORTING_READ_BASE_URL() {
    return process.env.REACT_APP_REPORTING_READ_BASE_URL;
  }

  static get REPORTING_VIRTUAL_EVENT_READ_BASE_URL() {
    return process.env.REACT_APP_REPORTING_VIRTUAL_EVENT_READ_BASE_URL;
  }

  static get GET_VIRTUAL_EVENTS_LIST_URL() {
    return process.env.REACT_APP_REPORTING_GET_VIRTUAL_EVENTS_BASE_URL;
  }

  static get ACCOUNT_SERVICE_BASE_URL() {
    return process.env.REACT_APP_ACCOUNT_SERVICE_BASE_URL;
  }

  static get G2W_BROKER_BASE_URL() {
    return process.env.REACT_APP_G2W_BROKER_BASE_URL;
  }

  static get AVATAR_SERVICE_BASE_URL() {
    return process.env.REACT_APP_AVATAR_SERVICE_BASE_URL;
  }

  static get SUPPORT_URL() {
    return process.env.REACT_APP_SUPPORT_URL;
  }

  static get G2S_URL() {
    return process.env.REACT_APP_G2S_URL;
  }

  static get G2S_API_URL() {
    return process.env.REACT_APP_G2S_API_URL;
  }

  static get G2M_API_URL() {
    return process.env.REACT_APP_G2M_API_URL;
  }

  static get MY_ACCOUNT_URL() {
    return process.env.REACT_APP_MY_ACCOUNT_URL;
  }

  static get G2W_DASHBOARD_URL() {
    return process.env.REACT_APP_G2W_DASHBOARD_URL;
  }

  static get AUTH_CLIENT_ID() {
    return process.env.REACT_APP_AUTH_CLIENT_ID;
  }

  static get SESSIONS_DATA_FETCH_THRESHOLD_VALUE() {
    return process.env.REACT_APP_SESSIONS_DATA_FETCH_THRESHOLD_VALUE;
  }

  static get SESSIONS_DATA_FETCH_SIZE() {
    return process.env.REACT_APP_SESSIONS_DATA_FETCH_SIZE;
  }

  static get MIXPANEL_TOKEN() {
    return process.env.REACT_APP_MIXPANEL_TOKEN;
  }

  static get MIXPANEL_CROSS_PLATFORM_TOKEN() {
    return process.env.REACT_APP_MIXPANEL_CROSS_PRODUCT_TOKEN;
  }

  static get INTERCOM_ID() {
    return process.env.REACT_APP_INTERCOM_ID;
  }

  static get INTERCOM_ENABLED() {
    return process.env.REACT_APP_INTERCOM_ENABLED === 'true';
  }

  static get APPCUES_ENABLED() {
    return process.env.REACT_APP_APPCUES_ENABLED === 'true';
  }
  static get REPORT_GENERATION_RETRY_COUNT() {
    return process.env.REACT_APP_REPORT_GENERATION_RETRY_COUNT;
  }

  static get REPORT_MAXIMUM_SESSIONS_COUNT() {
    return process.env.REACT_APP_REPORT_MAXIMUM_SESSIONS_COUNT;
  }
  static get REPORT_MAXIMUM_REGISTRANTS_COUNT() {
    return process.env.REACT_APP_REPORT_MAXIMUM_REGISTRANTS_COUNT;
  }
  static get REPORT_MAXIMUM_ENGAGEMENT_COUNT() {
    return process.env.REACT_APP_REPORT_MAXIMUM_ENGAGEMENT_COUNT;
  }
  static get REPORT_SHOW_INLINE_WARNING_COUNT() {
    return process.env.REACT_APP_REPORT_SHOW_INLINE_WARNING_COUNT;
  }
  static get IS_NEW_MANAGE_CHANNEL_PAGE_ENABLED() {
    return process.env.REACT_APP_IS_NEW_MANAGE_CHANNEL_PAGE_ENABLED === 'true';
  }
  static get SESSION_PROCESSING_MESSAGE_TIME_IN_MILLIS() {
    return process.env.REACT_APP_SESSION_PROCESSING_MESSAGE_TIME_IN_MILLIS;
  }

  static get TIPS_ENABLED() {
    return process.env.REACT_APP_TIPS_ENABLED === 'true';
  }

  static get APPLICATION_STATE_SERVICE_BASE_URL() {
    return process.env.REACT_APP_STATE_BASE_URL;
  }
}
export default AppConstants;



// WEBPACK FOOTER //
// ./src/AppConstants.js